import ReactGA from "react-ga4";
import {Button} from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import Tooltip from "@mui/material/Tooltip";
import React from "react";

export default function BuyEasyCart({id, offerType, objectType}) {

//    const windowFeatures = "left=0,top=0,width=320,height=320";

    const handleBuy = (offerType, objectType) => {
        ReactGA.event({category: "purchase", action: 'purchase'}, {id: id});
        window.open(`https://app.easycart.pl/checkout/50766280/${id}`, '_blank');
    }

    switch (objectType) {
        case 'sealed':
            return (
                <Button variant="outlined"
                        onClick={() => handleBuy(offerType, objectType)}
                        endIcon={<AddShoppingCartIcon/>}>{offerType ? 'Buy' : 'Sell'}</Button>
            )
        default:
            return (
                <Tooltip title="Available soon" placement="top">
                    <Button variant="outlined"
                            endIcon={<AddShoppingCartIcon/>}>{offerType ? 'Buy' : 'Sell'}</Button>
                </Tooltip>
            )
    }

}
